import * as d3 from 'd3';
import Abstract from './Abstract.js';

export default class Tooltip extends Abstract {
  constructor(props) {
    super(props);
  }

  addHoverToRow() {
    const { chart, options } = this.props;
    const that = this;
    chart
      .selectAll('rect')
      // .on('click', (d) => {
      //   d.onClick();
      //   d3.select('#tooltip').classed('show', false);
      // })
      .on('mousemove', function (d) {
        if (d.type === 'milestone') return;
        let leftEdge = false;
        let rightEdge = false;

        let xPosition = d3.event.pageX;
        let yPosition =
          parseFloat(d3.select(this).attr('y')) +
          (that.props.options.barHeight + 5);
        if (xPosition < 150) {
          xPosition += 15;
          yPosition -= 15;
          leftEdge = true;
        }

        if (xPosition > that.props.options.width - 150) {
          yPosition -= 15;
          rightEdge = true;
        }

        const tooltip = d3
          .select('#tooltip')
          .classed('show', true)
          .classed('left-edge', leftEdge)
          .classed('right-edge', rightEdge)
          .style('left', `${xPosition}px`)
          .style('top', `${yPosition}px`);

        tooltip.select('#title').text(d.title);

        d.category ? tooltip.select('#category').text(d.category.name) : null;

        tooltip.select('#type').text(d.type);
      })
      .on('mouseout', () => {
        const tooltip = d3.select('#tooltip');
        tooltip.classed('show', false);
        tooltip.select('#title').text(null);
        tooltip.select('#category').text(null);
        tooltip.select('#type').text(null);
      });
  }

  build() {
    this.addHoverToRow();
  }
}
